import { AuthStorage } from '@capturum/auth';

/**
 * A legacy student handshake arrives as `?legacyKey=` in a tab that Intergrip 1.0 opened with
 * `window.open(..., 'noopener')`, so that tab starts with an empty sessionStorage. When somebody is
 * already logged in on this origin — typically a supervisor impersonating the student — the student
 * session must not take over their `token`. Isolating the tab keeps the handshake's identity in
 * sessionStorage, private to the tab and gone when it closes.
 *
 * Must run before Angular bootstraps: AuthService seeds its authentication state at DI time.
 */
export function isolateSessionForLegacyHandshake(search: string): void {
  if (new URLSearchParams(search).has('legacyKey') && localStorage.getItem('token')) {
    AuthStorage.isolate();
  }
}
